/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { Fragment, memo, ReactNode, RefObject, useEffect, useRef, useState } from 'react';

import { TableFooterStyled } from '../../../components/Table/styled/TableStyled';
import { TableFooterStickyStyled } from './styled/TableFooterStyled';
import TableHorizontalScroll from './TableHorizontalScroll';

interface ITableFooter {
    footer?: (HorScroll: ReactNode) => ReactNode;
    tableRef: RefObject<HTMLDivElement>;
    totalColumnsWidth: number;
}

const TableFooter = ({ footer, tableRef, totalColumnsWidth }: ITableFooter) => {

    const [height, setHeight] = useState(0);

    const tableFooterRef = useRef<HTMLDivElement>(null);
    const HorizontalScroll = <TableHorizontalScroll
        tableRef={tableRef}
        totalColumnsWidth={totalColumnsWidth}
    />;

    useEffect(() => {
        setHeight(tableFooterRef?.current?.clientHeight ?? 0);
    }, [footer, tableFooterRef?.current?.clientHeight]);


    return (
        <Fragment>
            <TableFooterStyled ref={tableFooterRef}>
                {footer?.(HorizontalScroll) ?? HorizontalScroll}
            </TableFooterStyled>
            <TableFooterStickyStyled style={{ height }}/>
        </Fragment>
    );
};

export default memo(TableFooter);
